/**
 * Edit Player Modal - Form for updating player information
 */

import { Player } from "../types/index.js";
import { closeOnBackdropClick } from "../utils/ui";
import { renderPlayerFormCard, validatePlayerForm } from "./playerForm";

export class EditPlayerModal {
  private modal: HTMLDivElement;
  private resolve: ((value: any) => void) | null = null;

  constructor() {
    this.modal = document.createElement("div");
    this.setupModal();
  }

  private setupModal() {
    this.modal.className =
      "hidden fixed inset-0 bg-slate-900/80 backdrop-blur-sm flex items-center justify-center z-50 p-4";
    this.modal.innerHTML = renderPlayerFormCard({
      title: "Edit Player",
      formId: "editPlayerForm",
      nameLabel: "Player Name",
      submitIcon: "save",
      submitLabel: "Update Player",
    });

    document.body.appendChild(this.modal);
    this.attachEventListeners();
  }

  private attachEventListeners() {
    const form = this.modal.querySelector("#editPlayerForm") as HTMLFormElement;
    const cancelBtn = this.modal.querySelector("#cancelBtn") as HTMLButtonElement;

    form.addEventListener("submit", (e) => {
      e.preventDefault();
      this.handleSubmit();
    });

    cancelBtn.addEventListener("click", () => {
      this.close();
    });

    closeOnBackdropClick(this.modal, () => this.close());
  }

  private handleSubmit() {
    const nameInput = this.modal.querySelector("#playerName") as HTMLInputElement;
    const levelInput = this.modal.querySelector("#playerLevel") as HTMLSelectElement;
    const errorDiv = this.modal.querySelector("#errorMessage") as HTMLDivElement;

    const name = nameInput.value.trim();
    const level = parseInt(levelInput.value);

    const error = validatePlayerForm(name, level);
    if (error) {
      errorDiv.textContent = error;
      errorDiv.classList.remove("hidden");
      return;
    }

    const data: any = {
      name,
      level,
    };

    this.close();
    if (this.resolve) {
      this.resolve(data);
    }
  }

  private close() {
    this.modal.classList.add("hidden");
  }

  show(player: Player): Promise<{
    name?: string;
    level?: number;
  } | null> {
    return new Promise((resolve) => {
      this.resolve = resolve;

      const nameInput = this.modal.querySelector("#playerName") as HTMLInputElement;
      const levelInput = this.modal.querySelector("#playerLevel") as HTMLSelectElement;
      const errorDiv = this.modal.querySelector("#errorMessage") as HTMLDivElement;

      nameInput.value = player.name;
      levelInput.value = (player as any).level ? String((player as any).level) : "0";
      errorDiv.classList.add("hidden");

      this.modal.classList.remove("hidden");
      nameInput.focus();
    });
  }
}
